const _excluded = ["permissions"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class loginActionCreators.
 *
 */
// pako 3's ESM build exposes named exports only, so a default import resolves to
// undefined once webpack bundles it.
import { ungzip } from 'pako';
import { InteractionRequiredAuthError } from '@azure/msal-browser'; // Package is in dependencies

import jwt from '../utils/jsonwebtokenWrapper';
// Safe to ignore: ajax functions are only called at runtime, not during module initialization
import * as ajax from './ajax'; // eslint-disable-line import/no-cycle
import config from '../config.json';
import loginConstants from '../constants/loginConstants';
/* eslint-disable-next-line import/no-cycle */
import mfaActionCreators from './mfaActionCreators';
/* eslint-disable-next-line import/no-cycle */
import tokenErrorActions from './tokenErrorActionCreators';
import notificationActions from './notificationActionCreators';
import { getStorageInUse } from '../utils/storage';
import { getItem, setItem, removeItem } from '../utils/localStorage';
import channel from '../utils/broadcast';
import { processAutoLogoutDuration } from '../utils/autoLogoutConfig';
import { createMsalInstance, loginRequest } from '../lib/authentication/entra/msalConfig';
import { getSSOConfig } from '../lib/authentication/entra/discovery';
let timer;
let timerStartTimestamp = null; // Track when the timer was set to prevent reset issues

// Constants for logout messages
const LOGOUT_MESSAGES = {
  BASE: 'You have been automatically logged out due to inactivity.',
  MANUAL_BASE: 'You have logged out.',
  SAVE_SUCCESS: 'Your changes have been saved.',
  SAVE_FAILED: 'Changes could not be saved.',
  SAVE_ERROR: 'Unable to save changes.'
};
const acceptCUIPolicy = () => ({
  type: loginConstants.ACCEPT_CUI_POLICY
});
const enforceCUIPolicy = () => ({
  type: loginConstants.ENFORCE_CUI_POLICY
});
const forgotPasswordFail = error => dispatch => {
  dispatch(notificationActions.error({
    message: error.response.data.error_msg
  }));
  dispatch({
    type: loginConstants.FORGOT_PASSWORD_FAIL
  });
};
const forgotPasswordSuccess = message => dispatch => {
  dispatch(notificationActions.info({
    message
  }));
  dispatch({
    type: loginConstants.FORGOT_PASSWORD_SUCCESS
  });
};
const forgotPasswordToggle = () => ({
  type: loginConstants.FORGOT_PASSWORD_TOGGLE
});
const passwordSaveSuccess = () => ({
  type: loginConstants.PASSWORD_SAVE_SUCCESS
});
const geolocationFailure = () => ({
  type: loginConstants.GEOLOCATION_FAILURE
});
const geolocationSuccess = data => ({
  type: loginConstants.GEOLOCATION_SUCCESS,
  data
});
const login = () => ({
  type: loginConstants.LOGIN
});
const loginFail = (error, customer) => ({
  type: loginConstants.LOGIN_FAIL,
  data: error,
  customer
});
const autoLogoutWithSave = message => ({
  type: loginConstants.AUTO_LOGOUT_WITH_SAVE,
  data: {
    error_msg: message
  }
});
const loginSuccess = user => ({
  type: loginConstants.LOGIN_SUCCESS,
  user
});

/**
 * Clear auth state on logout. SessionStorage is cleared entirely (only used for auth:
 * our keys + MSAL cache). LocalStorage: only these keys are removed so logoutMessage
 * is preserved for the login page. Remember Me (cookies) is unchanged.
 */
const LOCAL_STORAGE_AUTH_KEYS = ['user', 'geolocation', 'refresh_token', 'forcedRefreshDate', 'upgradeTokenDate'];
const clearAuthStateOnLogout = () => {
  LOCAL_STORAGE_AUTH_KEYS.forEach(key => removeItem(key));
  if (typeof global.sessionStorage === 'undefined') return;
  try {
    global.sessionStorage.clear();
  } catch (_unused) {
    // SessionStorage may be disabled (e.g. private browsing)
  }
};
const logoutUser = (shouldBroadcast = true) => dispatch => {
  clearTimeout(timer);
  timer = null;
  timerStartTimestamp = null;
  if (shouldBroadcast) {
    channel.postMessage({
      type: 'logout'
    });
  }
  clearAuthStateOnLogout();
  dispatch(notificationActions.dismiss()); // close any active notifications
  dispatch({
    type: loginConstants.LOGOUT
  });
};
const mfaRequired = (error, user) => ({
  type: loginConstants.MFA_REQUIRED,
  data: error,
  user
});
const mfaSetupRequired = (error, user) => ({
  type: loginConstants.MFA_SETUP_REQUIRED,
  data: error,
  user
});
const passwordExpired = (error, user) => ({
  type: loginConstants.PASSWORD_EXPIRED,
  data: error,
  user
});
const token = () => ({
  type: loginConstants.TOKEN
});
const tokenSuccess = () => async (dispatch, getState) => {
  const {
    actionsToRetry,
    pendingTokenRequest
  } = getState().tokenError;
  if (actionsToRetry && actionsToRetry.length > 0 && pendingTokenRequest) {
    for (let i = 0; i < actionsToRetry.length; i += 1) {
      const retryAction = actionsToRetry[i];
      /* eslint-disable-next-line no-await-in-loop */
      await dispatch(retryAction());
    }
    dispatch(tokenErrorActions.reset());
  }
  dispatch({
    type: loginConstants.TOKEN_SUCCESS
  });
};
const getGeolocation = () => dispatch => {
  if (global.navigator && global.navigator.geolocation) {
    global.navigator.geolocation.getCurrentPosition(position => {
      if (position.coords && position.coords.longitude && position.coords.latitude) {
        const geolocation = {
          longitude: position.coords.longitude.toFixed(4),
          latitude: position.coords.latitude.toFixed(4)
        };
        dispatch(geolocationSuccess(geolocation));
      } else {
        dispatch(geolocationFailure());
      }
    });
  } else {
    dispatch(geolocationFailure());
  }
};

/*
 * Save the changes to the entity
 * @param {Object} activeEntity - The active entity
 * @param {string} entityType - The type of entity
 * @param {Function} getState - The getState function
 * @param {Function} dispatch - The dispatch function
 * @param {Object|undefined} postOpts - Optional ajax post options (e.g. { oneLastSave: true }).
 */
const saveEntityChanges = async (activeEntity, entityType, getState, dispatch, postOpts) => {
  var _newState$entityType;
  const actions = await import(`./${entityType}ActionCreators`);
  const saveTrigger = entityType === 'reportAnnotation' ? activeEntity : activeEntity.content.version;
  await dispatch(actions.default.serverSave(saveTrigger, undefined, postOpts));
  const newState = getState();
  return ((_newState$entityType = newState[entityType]) === null || _newState$entityType === void 0 ? void 0 : _newState$entityType.pendingChanges) !== true;
};

/**
 * Check if and which entity has pending changes
 */
const entityWithChanges = state => {
  var _state$form, _state$issue, _state$report, _state$reportAnnotati;
  if ((_state$form = state.form) !== null && _state$form !== void 0 && _state$form.pendingChanges) return 'form';
  if ((_state$issue = state.issue) !== null && _state$issue !== void 0 && _state$issue.pendingChanges) return 'issue';
  if ((_state$report = state.report) !== null && _state$report !== void 0 && _state$report.pendingChanges) return 'report';
  if ((_state$reportAnnotati = state.reportAnnotation) !== null && _state$reportAnnotati !== void 0 && _state$reportAnnotati.pendingChanges) return 'reportAnnotation';
  return false;
};

/**
 * Helper function to save pending changes and then logout.
 * Used by idleTimer (auto-logout), logoutUserWithSave (manual logout), and forced
 * upgrade logout (403) when oneLastSave is true.
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} getState - Redux getState function
 * @param {boolean} isManualLogout - Whether this is a manual logout (default: false)
 * @param {boolean} useOneLastSave - Send X-One-Last-Save on save (403 upgrade flow)
 */
const logoutWithPendingChangesSave = async (dispatch, getState, isManualLogout = false, useOneLastSave = false) => {
  const state = getState();

  // Check for pending changes before logout
  const entityWithPendingChanges = entityWithChanges(state);
  if (entityWithPendingChanges) {
    try {
      const postOpts = useOneLastSave ? {
        oneLastSave: true
      } : undefined;
      const saveSuccess = await saveEntityChanges(state[entityWithPendingChanges].active, entityWithPendingChanges, getState, dispatch, postOpts);

      // Use appropriate base message based on logout type
      const baseMessage = isManualLogout ? LOGOUT_MESSAGES.MANUAL_BASE : LOGOUT_MESSAGES.BASE;
      // Store logout message in localStorage before logout
      setItem('logoutMessage', `${baseMessage} ${saveSuccess ? LOGOUT_MESSAGES.SAVE_SUCCESS : LOGOUT_MESSAGES.SAVE_FAILED}`);

      // Proceed with logout regardless of save results
      dispatch(logoutUser());
    } catch (error) {
      // If save process fails completely, still logout but show error message
      // eslint-disable-next-line no-console
      console.error('Error saving pending changes:', error);
      const baseMessage = isManualLogout ? LOGOUT_MESSAGES.MANUAL_BASE : LOGOUT_MESSAGES.BASE;
      setItem('logoutMessage', `${baseMessage} ${LOGOUT_MESSAGES.SAVE_ERROR}`);
      dispatch(logoutUser());
    }
  } else {
    // No pending changes, but still show logout message
    const baseMessage = isManualLogout ? LOGOUT_MESSAGES.MANUAL_BASE : LOGOUT_MESSAGES.BASE;
    setItem('logoutMessage', baseMessage);
    dispatch(logoutUser());
  }
};

/**
 * @method logoutUserWithSave
 * Logs out the user after attempting to save any pending changes.
 * Uses the same save-before-logout logic as auto-logout.
 * @param {{ oneLastSave?: boolean }} [options] - When oneLastSave is true (403 forced
 *   upgrade logout), the save request includes the one last save header so the server allows it.
 */
const logoutUserWithSave = (options = {}) => async (dispatch, getState) => {
  const {
    oneLastSave = false
  } = options;
  await logoutWithPendingChangesSave(dispatch, getState, true, oneLastSave);
};

/**
 * Save pending changes without logging out.
 * Same save path as auto-logout (entityWithChanges + saveEntityChanges).
 * Used before forced page reload in 403 client-upgrade flow.
 * Sets the one last save flag so the server allows the write
 * even though the client version is outdated.
 */
const oneLastSavePendingChanges = () => async (dispatch, getState) => {
  const state = getState();
  const entityWithPendingChanges = entityWithChanges(state);
  if (!entityWithPendingChanges) return;
  try {
    await saveEntityChanges(state[entityWithPendingChanges].active, entityWithPendingChanges, getState, dispatch, {
      oneLastSave: true
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error saving pending changes before forced reload:', error);
  }
};

/**
 *  @method idleTimer looks at the last redux action and sets a timer
 */
const idleTimer = user => async (dispatch, getState) => {
  const state = getState();
  const {
    lastAction: {
      timestamp: lastActionTimestamp
    }
  } = state;

  // only set the idle timer if the user has it enabled
  if (user && user.logoutAfterIdleTime) {
    var _state$settings;
    const rawDuration = (_state$settings = state.settings) === null || _state$settings === void 0 || (_state$settings = _state$settings.settings) === null || _state$settings === void 0 || (_state$settings = _state$settings.configuration) === null || _state$settings === void 0 || (_state$settings = _state$settings.logoutProperties) === null || _state$settings === void 0 ? void 0 : _state$settings.autoLogoutDuration;
    const duration = processAutoLogoutDuration(rawDuration);
    const elapsed = Date.now() - lastActionTimestamp;

    // If timer was set and we're checking due to timer firing, use the original timestamp
    // This prevents actions that update lastAction.timestamp from resetting the timer
    const timestampToUse = timerStartTimestamp || lastActionTimestamp;
    const elapsedFromTimerStart = Date.now() - timestampToUse;

    // Check if we should logout based on either the current elapsed time OR the timer start time
    if (elapsed >= duration || timerStartTimestamp && elapsedFromTimerStart >= duration) {
      // Clear timer tracking
      clearTimeout(timer);
      timer = null;
      timerStartTimestamp = null;

      // Save pending changes and logout (shared logic with manual logout)
      await logoutWithPendingChangesSave(dispatch, getState, false);
    } else {
      // no ill effects of clearing timer if it's not yet defined
      clearTimeout(timer);
      const timeUntilLogout = duration - elapsed;

      // Store the timestamp when we set the timer
      timerStartTimestamp = lastActionTimestamp;

      // set timer for configured duration after the last action
      // Store user and getState in closure for the callback
      const currentUser = user;
      const currentGetState = getState;
      const currentDispatch = dispatch;
      timer = setTimeout(() => {
        try {
          var _freshState$login;
          // Get fresh user from state in case it changed
          const freshState = currentGetState();
          const freshUser = ((_freshState$login = freshState.login) === null || _freshState$login === void 0 ? void 0 : _freshState$login.user) || currentUser;
          if (freshUser && freshUser.logoutAfterIdleTime) {
            currentDispatch(idleTimer(freshUser));
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('[idleTimer] Error in timer callback:', error);
        }
      }, timeUntilLogout);
    }
  }
};

/**
 * @method getUserFromSession grab user and geolocation data from sessionStorage.
 * if found, go ahead and login the current user
 */
const getUserFromSession = () => dispatch => {
  channel.onmessage = event => {
    if (event.data.type === 'logout') {
      // Perform logout in this tab without rebroadcasting to avoid cross-tab loop
      dispatch(logoutUser(false));
    }
  };
  const storage = getStorageInUse();
  const geolocation = JSON.parse(storage.getItem('geolocation'));
  let user = null;
  try {
    const serializedUser = storage.getItem('user');
    if (serializedUser) {
      user = JSON.parse(serializedUser);
    }
  } catch (_unused2) {
    // no op
  }
  if (user) {
    if (geolocation && (geolocation.longitude || geolocation.latitude)) {
      // parse the lat/long strings
      dispatch(geolocationSuccess(_objectSpread(_objectSpread({}, geolocation), {}, {
        latitude: geolocation.latitude ? parseFloat(geolocation.latitude) : null,
        longitude: geolocation.longitude ? parseFloat(geolocation.longitude) : null
      })));
    } else {
      dispatch(getGeolocation());
    }
    // Check to see if the user has auto-logout enabled and reset timer if so.
    dispatch(idleTimer(user));
    return dispatch(loginSuccess(user));
  }
  return true;
};

/**
 * @method serverForgotPassword
 */
const serverForgotPassword = (customer, username) => async dispatch => {
  const forgotPasswordData = {
    clientID: customer,
    username
  };
  try {
    const {
      data
    } = await ajax.post(ajax.getURL('resetPassword'), forgotPasswordData, false);
    return dispatch(forgotPasswordSuccess(data.message));
  } catch (e) {
    return dispatch(forgotPasswordFail(e));
  }
};

/**
 * @method processAccessTokenResponse
 * Processes an access token response from the server, decodes the token,
 * decompresses permissions, merges metadata, handles CUI policy, sets idle timer,
 * and dispatches login success.
 * @param {Object} responseData - The response data from the server containing
 *   access_token and metadata
 * @param {string} customer - The customer identifier
 * @param {Function} dispatch - Redux dispatch function
 * @param {Function} getState - Redux getState function
 * @param {Object} decodedRefreshToken - Optional decoded refresh token for CUI policy check
 * @param {boolean} dispatchTokenSuccess - Whether to dispatch tokenSuccess
 *   (for token refresh flow)
 * @returns {Promise} Promise that resolves when processing is complete
 */
const processAccessTokenResponse = async (responseData, customer, dispatch, getState, decodedRefreshToken = null, dispatchTokenSuccess = false) => {
  // Validate access token is present
  if (!responseData.access_token) {
    dispatch(loginFail({
      error_msg: 'no access_token in response'
    }, customer));
    return null;
  }

  // Decode the access token and set the user
  let user = jwt.decode(responseData.access_token);
  // Set the access token in the user
  user.access_token = responseData.access_token;

  // Decompress permissions (guard presence and wrap decode in try/catch)
  if (!responseData.permissions || typeof responseData.permissions !== 'string' || responseData.permissions.length === 0) {
    dispatch(loginFail({
      error_msg: 'permissions decode failed: permissions missing or invalid'
    }, customer));
    return null;
  }
  try {
    const zippedPermissions = Buffer.from(responseData.permissions, 'base64');
    // pako 3 dropped the { to: 'string' } option and always returns bytes.
    const permissionStr = Buffer.from(ungzip(zippedPermissions)).toString('utf8');
    user.permissions = JSON.parse(permissionStr);
  } catch (err) {
    dispatch(loginFail({
      error_msg: `permissions decode failed: ${err.message}`
    }, customer));
    return null;
  }

  // Create a copy of responseData without permissions to avoid mutating the parameter
  const {
      permissions
    } = responseData,
    responseDataWithoutPermissions = _objectWithoutProperties(responseData, _excluded);

  // Merge metadata (build, version, etc.) with user data
  user = _objectSpread(_objectSpread({}, responseDataWithoutPermissions), user);

  // Handle CUI policy check
  // Use decodedRefreshToken if provided (for token refresh flow), otherwise decode from user
  const tokenForCUIPolicy = decodedRefreshToken || user;
  if (tokenForCUIPolicy.enforceCUIPolicy === 1 && !getState().login.acceptedCUIPrompt) {
    dispatch(enforceCUIPolicy());
  }

  // Check to see if the user has auto-logout enabled and set timer if so
  dispatch(idleTimer(user));

  // Dispatch LOGIN_SUCCESS first so that retry methods have the updated token
  dispatch(loginSuccess(user));

  // For token refresh flow, dispatch tokenSuccess to handle retry actions
  if (dispatchTokenSuccess) {
    return dispatch(tokenSuccess());
  }
  return user;
};

/**
 * @method serverTokenEntra
 * Token refresh flow for Entra users using RFC 8693 Token Exchange pattern.
 * Acquires new Entra token silently, then exchanges for Tru access token.
 *
 * @param {string} customer - Customer name
 * @param {Object} [existingMsalInstance] - Pre-initialized MSAL instance from serverToken
 */
const serverTokenEntra = (customer, existingMsalInstance) => async (dispatch, getState) => {
  let msalInstance = existingMsalInstance;
  if (!msalInstance) {
    // Fallback: create/init when called without pre-initialized instance
    let customerSettings = null;
    const storedSettingsStr = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('entra_customer_settings') : null;
    if (storedSettingsStr) {
      try {
        customerSettings = JSON.parse(storedSettingsStr);
      } catch (_unused3) {
        // Ignore parse errors
      }
    }
    msalInstance = customerSettings ? createMsalInstance(customerSettings) : null;
    if (!msalInstance) {
      dispatch(loginFail({
        error_msg: 'SSO sign-in is not available'
      }, customer));
      return dispatch(logoutUser());
    }
    try {
      await msalInstance.initialize();
    } catch (_unused4) {
      // Ignore initialization errors if already initialized
    }
  }

  // Get MSAL accounts
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    // No accounts - user must login
    dispatch(loginFail({
      error_msg: 'No SSO account found. Please sign in again.'
    }, customer));
    return dispatch(logoutUser());
  }
  dispatch(token());
  const [account] = accounts;
  try {
    // Get new Entra token silently
    const silentResponse = await msalInstance.acquireTokenSilent({
      scopes: loginRequest.scopes,
      account
    });

    // Exchange Entra token for Tru access token (RFC 8693)
    const tokenURL = ajax.getURL('/token', customer);
    const tokenData = {
      grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
      subject_token: silentResponse.idToken,
      subject_token_type: 'urn:ietf:params:oauth:token-type:jwt',
      client_version: config.version,
      client_type: 'web'
    };
    const exchangeResponse = await ajax.postNoPreflight(tokenURL, tokenData, false);

    // Process access token response using helper function
    // Note: decodedRefreshToken is null for Entra flow (CUI policy checked from user object)
    return processAccessTokenResponse(exchangeResponse.data, customer, dispatch, getState, null,
    // decodedRefreshToken = null (not needed for Entra flow)
    true // dispatchTokenSuccess = true for token refresh flow
    );
  } catch (msalError) {
    // MSAL error - may require user interaction
    if (msalError instanceof InteractionRequiredAuthError) {
      // User interaction required - redirect to login
      dispatch(loginFail({
        error_msg: 'Sign-in requires user interaction. Please sign in again.'
      }, customer));
      return dispatch(logoutUser());
    }

    // Other MSAL errors
    // eslint-disable-next-line no-console
    console.error('serverTokenEntra MSAL error:', msalError);
    dispatch(loginFail({
      error_msg: `Sign-in failed: ${msalError.message || 'Unknown error'}. Please sign in again.`
    }, customer));
    return dispatch(logoutUser());
  }
};

/**
 * @method serverTokenRefreshToken
 * Token refresh flow for non-Entra users using refresh token (backward compatibility).
 */
const serverTokenRefreshToken = customer => async (dispatch, getState) => {
  // get the refresh_token from localStorage
  const refreshToken = getItem('refresh_token');
  if (!refreshToken) {
    dispatch(loginFail({
      error_msg: 'no refresh token'
    }, customer));
    // without a refresh token the user must be logged out
    return dispatch(logoutUser());
  }
  dispatch(token());
  const decoded = jwt.decode(refreshToken);

  // get access_token from /token
  const tokenURL = ajax.getURL('/token', decoded.customer);
  const tokenData = {
    client_version: config.version,
    grant_type: 'refresh_token',
    refresh_token: refreshToken
  };
  let incomingTokenResponse;
  try {
    incomingTokenResponse = await ajax.postNoPreflight(tokenURL, tokenData, false);
  } catch (e) {
    dispatch(loginFail({
      error_msg: `token refresh failure ${e.responseText}`
    }, customer));
    // without a refresh token the user must be logged out
    return dispatch(logoutUser());
  }

  // Process access token response using helper function
  return processAccessTokenResponse(incomingTokenResponse.data, customer, dispatch, getState, decoded, true // dispatchTokenSuccess = true for token refresh flow
  );
};

/**
 *  @method serverToken Make a token request and login user on success
 *  For Entra users: Uses MSAL acquireTokenSilent() then exchanges for Tru access token (RFC 8693)
 *  For non-Entra users: Uses refresh token flow (backward compatibility)
 */
const serverToken = customer => async (dispatch, getState) => {
  // avoid repeated requests when the initial request is still loading
  if (getState().login.loading) {
    return null;
  }

  // Check if this is an Entra user (has MSAL account)
  // Get customer settings from sessionStorage to recreate instance
  let customerSettings = null;
  // Check for sessionStorage availability (may not be available in private browsing mode)

  if (typeof sessionStorage !== 'undefined' && sessionStorage) {
    try {
      const storedSettingsStr = sessionStorage.getItem('entra_customer_settings');
      if (storedSettingsStr) {
        try {
          customerSettings = JSON.parse(storedSettingsStr);
        } catch (_unused5) {
          // Ignore parse errors
        }
      }
    } catch (storageError) {
      // SessionStorage may be disabled - log warning but continue
      // eslint-disable-next-line no-console
      console.warn('Failed to read Entra settings from sessionStorage:', storageError);
    }
  }
  const msalInstance = customerSettings ? createMsalInstance(customerSettings) : null;
  let isEntraUser = false;
  if (msalInstance) {
    try {
      // MSAL requires initialize() before getAllAccounts() - calling getAllAccounts
      // without init can throw and would incorrectly fall back to refresh-token flow
      // (Entra users have no refresh token, causing logout)
      await msalInstance.initialize();
      isEntraUser = msalInstance.getAllAccounts().length > 0;
    } catch (msalError) {
      // Init or getAllAccounts failed - surface error instead of silently falling back
      // to refresh-token flow, which would incorrectly log out Entra users
      // eslint-disable-next-line no-console
      console.error('MSAL initialization or account detection failed:', msalError);
      return dispatch(loginFail({
        error_msg: 'Authentication check failed. Please try signing in again.'
      }, customer));
    }
  }
  if (isEntraUser) {
    // Entra user: Use RFC 8693 Token Exchange pattern (pass msalInstance to avoid duplicate init)
    return dispatch(serverTokenEntra(customer, msalInstance));
  }

  // Non-Entra user: Use refresh token flow (backward compatibility)
  return dispatch(serverTokenRefreshToken(customer));
};

/**
 * @method serverLogin
 * Log in the user using username/password (non-Entra flow).
 * Successful login will set refresh_token in local storage.
 * However, the user isn't fully logged in until they receive an
 * access token, so control will be passed to the token method and upon
 * it's success the LOGIN_SUCCESS event will be triggered.
 * For Entra users, use serverEntraLogin instead.
 */
const serverLogin = (customer, username, password, mfaPin) => async dispatch => {
  const loginURL = ajax.getURL('/login', customer);
  const loginData = {
    client_type: 'web',
    grant_type: 'password',
    username,
    password,
    mfaPin
  };
  dispatch(login());
  try {
    const incomingLoginResponse = await ajax.postNoPreflight(loginURL, loginData, false);

    // no refresh token
    if (!incomingLoginResponse.data.refresh_token) {
      return dispatch(loginFail({
        error_msg: 'no refresh token'
      }, customer));
    }

    // save the refresh_token to localStorage
    setItem('refresh_token', incomingLoginResponse.data.refresh_token);
    dispatch(getGeolocation());

    // get an access token via refresh_token flow (never use Entra flow after password login)
    return dispatch(serverTokenRefreshToken(customer));
  } catch (e) {
    const error = ajax.getError(e);

    // build a user object containing the temporary access token
    const user = {
      access_token: error.access_token,
      customer,
      user_id: error.user_id,
      username,
      permissions: {}
    };
    if (error.error_type === 'need_mfa_pin') {
      // MFA required
      return dispatch(mfaRequired(error, user));
    }
    if (error.error_type === 'wrong_mfa_pin') {
      // MFA entry failed, start over
      return dispatch(loginFail(error, customer));
    }
    if (error.error_type === 'setup_mfa_pin') {
      // MFA required, but not yet set up for this user
      dispatch(mfaSetupRequired(error, user));
      return dispatch(mfaActionCreators.startMFASetup(customer, username, password));
    }
    if (error.error_type === 'password_expired') {
      // user needs to choose a new password
      return dispatch(passwordExpired(error, user));
    }
    // All other errors
    return dispatch(loginFail(error, customer));
  }
};

/**
 * @method serverEntraLogin
 * Exchange Entra ID token for TruQC access token using RFC 8693 Token Exchange pattern.
 * This follows the single-step flow:
 * 1. Exchange Entra token for access_token + metadata (RFC 8693 token exchange)
 * 2. Process access token response directly (no refresh token needed)
 * This is called after MSAL redirects back with an authorization code
 */
const serverEntraLogin = (customer, entraIdToken) => async (dispatch, getState) => {
  const tokenURL = ajax.getURL('/token', customer);
  const tokenData = {
    grant_type: 'urn:ietf:params:oauth:grant-type:token-exchange',
    subject_token: entraIdToken,
    subject_token_type: 'urn:ietf:params:oauth:token-type:jwt',
    client_version: config.version,
    client_type: 'web' // Web client - don't require db_version
  };
  dispatch(login());
  try {
    // Exchange Entra token for access token + metadata (RFC 8693 Token Exchange)
    const exchangeResponse = await ajax.postNoPreflight(tokenURL, tokenData, false);

    // Server returns access_token + metadata from RFC 8693 token exchange
    if (!exchangeResponse.data.access_token) {
      return dispatch(loginFail({
        error_msg: 'Sign-in failed: no access token received. Please try again.'
      }, customer));
    }
    dispatch(getGeolocation());

    // Process access token response directly (no refresh token storage needed)
    // This will decode the token, decompress permissions, merge metadata,
    // handle CUI policy, set idle timer, and dispatch loginSuccess
    return processAccessTokenResponse(exchangeResponse.data, customer, dispatch, getState, null,
    // decodedRefreshToken = null (not needed for initial login)
    false // dispatchTokenSuccess = false (not a token refresh flow)
    );
  } catch (e) {
    var _e$response, _e$response2, _e$response3;
    const error = ajax.getError(e);
    // eslint-disable-next-line no-console
    console.error('serverEntraLogin error:', {
      error,
      response: e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.data,
      status: e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.status,
      statusText: e === null || e === void 0 || (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.statusText
    });
    return dispatch(loginFail(error, customer));
  }
};

/**
 * @method keepAlive
 * Dispatches a simple action to update lastAction.timestamp, resetting the idle timer
 */
const keepAlive = () => (dispatch, getState) => {
  // Reset timer tracking when user explicitly keeps alive
  timerStartTimestamp = null;
  dispatch({
    type: 'KEEP_ALIVE'
  });
  // Reset the idle timer with the updated timestamp
  const {
    login: {
      user
    }
  } = getState();
  if (user && user.logoutAfterIdleTime) {
    dispatch(idleTimer(user));
  }
};

/**
 * @method checkSSOConfig
 * Check SSO configuration for the given customer via RFC 8414 discovery endpoint.
 * Fetches SSO provider configurations from server and updates Redux state.
 * Supports multiple SSO providers (Entra, Okta, Google, etc.).
 *
 * @param {string} customerName - Customer name to check
 * @returns {Promise<Object>} Response with providers and availableProviders
 */
const checkSSOConfig = customerName => async (dispatch, getState) => {
  // Normalize customer name once - trim whitespace and convert to lowercase
  // This ensures consistent handling throughout the function and prevents issues
  // with leading/trailing spaces or mixed case in discovery URLs
  const normalizedCustomer = customerName ? customerName.trim().toLowerCase() : '';
  if (!normalizedCustomer) {
    dispatch({
      type: loginConstants.CHECK_SSO_CONFIG_FAIL
    });
    return {
      providers: {},
      availableProviders: []
    };
  }

  // Check for forceRegularLogin URL parameter (check both query params and hash params)
  // Parameter presence alone is sufficient (e.g., ?forceRegularLogin or ?forceRegularLogin=true)

  let forceRegularLogin = false;
  if (typeof window !== 'undefined') {
    // Check query parameters (e.g., ?forceRegularLogin or ?forceRegularLogin=true)

    const urlParams = new URLSearchParams(window.location.search);
    forceRegularLogin = urlParams.has('forceRegularLogin');

    // Also check hash parameters (e.g., #/login?forceRegularLogin)

    if (!forceRegularLogin && window.location.hash) {
      // Check if forceRegularLogin appears as a parameter (with or without value)

      forceRegularLogin = /[?&]forceRegularLogin(?:=|&|$)/.test(window.location.hash);
    }
  }
  if (forceRegularLogin) {
    // Skip SSO check if forceRegularLogin=true
    // Clear any stale Entra session so token refresh uses refresh_token, not Entra

    if (typeof sessionStorage !== 'undefined' && sessionStorage) {
      try {
        sessionStorage.removeItem('entra_customer_settings');
        sessionStorage.removeItem('entra_callback_processed');
      } catch (_unused6) {
        // SessionStorage may be disabled - continue
      }
    }
    dispatch({
      type: loginConstants.CHECK_SSO_CONFIG_FAIL
    });
    return {
      providers: {},
      availableProviders: []
    };
  }

  // Dispatch checking action for all providers (we'll refine this per-provider if needed)
  dispatch({
    type: loginConstants.CHECK_SSO_CONFIG,
    data: {
      provider: null,
      customer: normalizedCustomer
    } // customer for stale-response guard
  });
  try {
    var _getState$login;
    // Fetch SSO configuration from server via RFC 8414 discovery endpoint
    // Use normalized customer to ensure consistent URL construction
    const ssoConfig = await getSSOConfig(normalizedCustomer);

    // Build normalized provider data structure for Redux
    const providers = {};
    const availableProviders = ssoConfig.availableProviders || [];

    // Process each available provider
    availableProviders.forEach(providerName => {
      const providerData = ssoConfig.providers[providerName];
      if (providerData && providerData.enabled) {
        var _providerData$tenantI, _providerData$clientI, _providerData$authori, _providerData$redirec;
        // Build login URL based on provider type
        let loginUrl = null;
        if (providerName === 'entra' && providerData.authority) {
          loginUrl = `${providerData.authority}/oauth2/v2.0/authorize`;
        } else if (providerData.authorizationEndpoint) {
          loginUrl = providerData.authorizationEndpoint;
        } else if (providerData.authority) {
          // Generic OAuth 2.0 authorization endpoint pattern
          loginUrl = `${providerData.authority}/oauth2/authorize`;
        }

        // Whitelist only fields required by MSAL/UI to avoid payload bloat,
        // key collisions, and mixing raw metadata (e.g. tenant_id, enabled)
        providers[providerName] = {
          enabled: true,
          loginUrl,
          settings: {
            tenantId: (_providerData$tenantI = providerData.tenantId) !== null && _providerData$tenantI !== void 0 ? _providerData$tenantI : null,
            clientId: (_providerData$clientI = providerData.clientId) !== null && _providerData$clientI !== void 0 ? _providerData$clientI : null,
            authority: (_providerData$authori = providerData.authority) !== null && _providerData$authori !== void 0 ? _providerData$authori : null,
            redirectUri: (_providerData$redirec = providerData.redirectUri) !== null && _providerData$redirec !== void 0 ? _providerData$redirec : null
          }
        };
      }
    });

    // Stale-response guard: ignore if user changed customer before this response arrived
    const currentRequestCustomer = (_getState$login = getState().login) === null || _getState$login === void 0 ? void 0 : _getState$login.ssoConfigRequestCustomer;
    if (currentRequestCustomer !== normalizedCustomer) {
      return {
        providers: {},
        availableProviders: []
      };
    }

    // Dispatch success with normalized data
    dispatch({
      type: loginConstants.CHECK_SSO_CONFIG_SUCCESS,
      data: {
        providers,
        availableProviders
      }
    });
    return {
      providers,
      availableProviders
    };
  } catch (error) {
    var _getState$login2;
    // Handle errors gracefully - disable SSO if fetch fails
    // eslint-disable-next-line no-console
    console.warn('Failed to check SSO configuration:', error);

    // Stale-response guard: ignore if user changed customer before this response arrived
    const currentRequestCustomer = (_getState$login2 = getState().login) === null || _getState$login2 === void 0 ? void 0 : _getState$login2.ssoConfigRequestCustomer;
    if (currentRequestCustomer !== normalizedCustomer) {
      return {
        providers: {},
        availableProviders: []
      };
    }
    dispatch({
      type: loginConstants.CHECK_SSO_CONFIG_FAIL
    });
    return {
      providers: {},
      availableProviders: []
    };
  }
};

/**
 * @method clearSSOConfig
 * Clear SSO configuration from Redux state.
 */
const clearSSOConfig = () => ({
  type: loginConstants.CLEAR_SSO_CONFIG
});
const loginActions = {
  acceptCUIPolicy,
  autoLogoutWithSave,
  checkSSOConfig,
  clearSSOConfig,
  enforceCUIPolicy,
  forgotPasswordFail,
  forgotPasswordSuccess,
  forgotPasswordToggle,
  geolocationFailure,
  geolocationSuccess,
  getGeolocation,
  getUserFromSession,
  idleTimer,
  keepAlive,
  login,
  loginFail,
  loginSuccess,
  logoutUser,
  logoutUserWithSave,
  oneLastSavePendingChanges,
  mfaRequired,
  mfaSetupRequired,
  passwordExpired,
  passwordSaveSuccess,
  serverEntraLogin,
  serverForgotPassword,
  serverLogin,
  serverToken,
  token,
  tokenSuccess
};
export default loginActions;